<div [style.background-color]="colorSecondary">
  <img src="assets/previews/layout2/menu-top.png" class="img-fluid img-responsive" style="width: 100%;">
</div>
<div>
  <img src="assets/previews/layout2/header.png" class="img-fluid img-responsive" style="width: 100%;">
</div>
<div>
  <img src="assets/previews/layout2/menu.png" class="img-fluid img-responsive" style="width: 100%;">
</div>
<div>
  <img src="assets/previews/layout2/banner.png" class="img-fluid img-responsive" style="width: 100%;">
</div>
<div style="padding: 0 35px; margin: 0 auto;">
  <div [style.background-color]="colorSecondary">
    <img src="assets/previews/layout2/service.png" class="img-fluid img-responsive" style="width: 100%;">
  </div>
  <div [style.background-color]="colorSecondary">
    <img src="assets/previews/layout2/specialty.png" class="img-fluid img-responsive" style="width: 100%;">
  </div>
  <div [style.background-color]="colorSecondary">
    <img src="assets/previews/layout2/post.png" class="img-fluid img-responsive" style="width: 100%;">
  </div>
  <div [style.background-color]="colorPrimary">
    <img src="assets/previews/layout2/exam.png" class="img-fluid img-responsive" style="width: 100%;">
  </div>
</div>
<div>
  <img src="assets/previews/layout2/others.png" class="img-fluid img-responsive" style="width: 100%;">
</div>
<div [style.background-color]="colorPrimary">
  <img src="assets/previews/layout2/footer.png" class="img-fluid img-responsive" style="width: 100%;">
</div>
<div [style.background-color]="colorSecondary">
  <img src="assets/previews/layout2/signature.png" class="img-fluid img-responsive" style="width: 100%;">
</div>